import {
    Component,
    forwardRef,
    Input,
    Inject,
    Output,
    EventEmitter,
} from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { AlertController } from "@ionic/angular";
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { UpdatePartnerDialogDialogComponent } from "./dialog/updatepartnerdialog.dialog.component";
import { RouteCMRController } from "@shared/src/controllers/route/cmr/routecmr.controller";
import { Incoterms } from "@shared/src/public-api";
import { ManualAddressDto } from "@shared/src/controllers/maps/ManualAddressDto";

export const SharedUpdatePartnerDialogComponent_NOSEPERQUESERVEIXA: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UpdatePartnerDialogDialogComponent),
    multi: true,
};

@Component({
    selector: "updatepartner-dialog",
    templateUrl: "./shared.updatepartnerdialog.component.html",
    styleUrls: ["./shared.updatepartnerdialog.component.scss"],
    providers: [SharedUpdatePartnerDialogComponent_NOSEPERQUESERVEIXA],
})
export class SharedUpdatePartnerDialogComponent {
    @Output() public onConfirm: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    @Output() public onCancel: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Input() title: string = "";
    @Input() paramstitle: any;

    @Input() routePartCMRId: number;

    @Input() partnerType: "carrier" | "effectivecarrier" | "payer" | "applicant" | "origin" | "destination";
    @Input() tenantId: number;
    @Input() name: string;
    @Input() nif: string;
    @Input() manualAddress: ManualAddressDto;
    @Input() contactPhone: string;
    @Input() contactName: string;
    @Input() external: boolean;

    private _expanded: boolean = false;
    @Input() public set expanded(value: boolean) {
        if (value)
            this.clickHelpNoIonic();

        this._expanded = value;
    }

    public get expanded(): boolean {
        return this._expanded;
    }

    public useIonic: boolean = false;

    public position = "below";

    constructor(
        private translate: TranslateService,
        private mdDialog: MatDialog,
        @Inject("HomeController") protected homecontroller: HomeController
    ) {
        if (homecontroller.useIonic) this.useIonic = homecontroller.useIonic();
    }

    ngOnInit() { }

    clickHelpNoIonic() {
        console.log(this.partnerType);
        let dialog = this.mdDialog.open(UpdatePartnerDialogDialogComponent, {
            disableClose: true,
            width: "600px",
            maxHeight: '90vh',
            //height: '300px',
            data: {
                title: this.gettitle(),
                routePartCMRId: this.routePartCMRId,
                partnerType: this.partnerType,
                tenantId: this.tenantId,
                name: this.name,
                nif: this.nif,
                manualAddress: this.manualAddress,
                contactName: this.contactName,
                contactPhone: this.contactPhone,
                external: this.external
            },
        });

        dialog.backdropClick().subscribe((data) => {
            this.onCancel.next(true);
        });

        dialog.componentInstance.onResolve.subscribe((data: boolean) => {
            if (data) this.onConfirm.next(true);
            else this.onCancel.next(true);
        });

        this.mdDialog.afterAllClosed.subscribe(() => { });
    }

    gettitle() {
        if (this.title != null && this.title != "")
            return this.translate.instant(
                this.title,
                this.paramstitle
            );

        return "";
    }
}
